var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardChartBlueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 36,
    viewBox: "0 0 52 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.5C0 18.3954 0.895431 17.5 2 17.5C3.10457 17.5 4 18.3954 4 19.5V35.5H0V19.5Z",
    fill: "#00B8D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.5C8 1.39543 8.89543 0.5 10 0.5C11.1046 0.5 12 1.39543 12 2.5V35.5H8V2.5Z",
    fill: "#00B8D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.5C16 14.3954 16.8954 13.5 18 13.5C19.1046 13.5 20 14.3954 20 15.5V35.5H16V15.5Z",
    fill: "#00B8D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.5C24 14.3954 24.8954 13.5 26 13.5C27.1046 13.5 28 14.3954 28 15.5V35.5H24V15.5Z",
    fill: "#00B8D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 6.5C32 5.39543 32.8954 4.5 34 4.5C35.1046 4.5 36 5.39543 36 6.5V35.5H32V6.5Z",
    fill: "#00B8D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 17.5C40 16.3954 40.8954 15.5 42 15.5C43.1046 15.5 44 16.3954 44 17.5V35.5H40V17.5Z",
    fill: "#00B8D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48 15.5C48 14.3954 48.8954 13.5 50 13.5C51.1046 13.5 52 14.3954 52 15.5V35.5H48V15.5Z",
    fill: "#00B8D9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardChartBlueIcon);
export default __webpack_public_path__ + "static/media/dashboard_chart_blue_icon.e7cbed4d976a7cf5b4e33255d526c243.svg";
export { ForwardRef as ReactComponent };